import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import formatDatetime from "../utils/formatDateTime.js";
import { getBanner, deleteBanner } from "../api/banner_api.js"
import { formatDateYYYYMMDD } from "../utils/formatDate.js";
import { Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faMagnifyingGlass,faPlus } from '@fortawesome/free-solid-svg-icons';
import TableData from "../components/table/TableData"
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';

function HeadBanner() {
    const navigate = useNavigate();
    const navigateToAddPage = () => {
        navigate("/eInfoHeadBanner");
    };

    const [dataTable, setDatatable] = useState([]);

    const dataHeader = [
        { label: "No",column:'no' , style: { width: "10%", borderLeft: "1px solid #000",borderTopLeftRadius: "10px",borderTopRightRadius: "0px",borderBottomLeftRadius: "10px"
        ,borderBottomRightRadius: "0px",position:'relative' },status: true
        },
        { label: "Title",column:'name' , style: { width: "25%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Update",column:'updated_at', style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Status",column:'active' , style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Action",column:'action', style: { width: "15%",borderRight: "1px solid #000",borderTopRightRadius: "10px",borderTopLeftRadius: "0px",borderBottomRightRadius: "10px",borderBottomLeftRadius: "0px"
        ,position:'relative' } }
    ];
    const [tableParam, setTableParam] = useState({
        sorting:{ column: "", order: "" },
        pageNumber:1,
        dataPerPage:10,
    }); //กำหนด column เริ่มต้นในการ sort
    const [totalNumber, setTotalNumber] = useState(0)
    useEffect(()=>{
        getTableData()
    },[tableParam])
    // const seachTable = (column,value) => {
    //     setTableParam((prevTableParam) => ({
    //         ...prevTableParam,
    //         searching: {...prevTableParam.searching,[column]:value},
    //       }));
    //   //newSorting example 
    // };
    const sortTable = (newSorting) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            sorting: newSorting,
        }));   
    };    
    const changePage = (pageNumber) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            pageNumber: pageNumber,
        }));   
      //newSorting example 1
    };
    const changeDataPerPage = (dataPerPage) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            dataPerPage: dataPerPage,
        }));   
      //newSorting example 10
    };

    const mapBannerSubcategory = (subcategory) => {
        switch (subcategory) {
            case "job":
                return "Careers";
            case "aboutus":
                return "About Us";
            case "contactus":
                return "Contact Us";
            case "our_service":
                return "Our Services &  Privileges";
            case "promo":
                return "Promotions & Privileges";
            case "news":
                return "News & Event";
            case "bidding":
                return "Open Tendering Project";
            default:
                return subcategory;
        }
    };

    async function getTableData() {
        try {
            setLoading(true);
            const param = {
                banner_category: 'head_banner',
                sort_by: tableParam.sorting.column === 'no' ? '_id' : tableParam.sorting.column,
                order_by: tableParam.sorting.order,
                page_number: tableParam.pageNumber,
                data_per_page: tableParam.dataPerPage,
            };
            let response = await getBanner(param);
            setTotalNumber(response.data.meta.total);

            let tmpDataTable = response.data.data.map((item, index) => {
                const ascendingNo = { data: (index + 1) + ((tableParam.pageNumber - 1) * tableParam.dataPerPage) };
                const descendingNo = { data: response.data.meta.total - ((tableParam.pageNumber - 1) * tableParam.dataPerPage) - index };

                return {
                    no: tableParam.sorting.order === 'desc' && tableParam.sorting.column === 'no' ? descendingNo : ascendingNo,
                    user_id: { data: item._id, isHide: true },
                    name: { data: mapBannerSubcategory(item.banner_subcategory) },
                    updated_at: { data: item.update_by + ' | ' + formatDatetime(item.updated_at) },
                    active: {
                        data: item.active === 1 ? "Active" : "Inactive",
                        style: { color: item.active === 1 ? "#87BD66" : "#D95350" },
                    },
                    action: {
                        view: false,
                        create: false,
                        delete: false,
                        update: false,
                        edit: true,
                    },
                };
            });

            setDatatable(tmpDataTable);
        } catch (error) {
            console.log('err getTableData', error);
        }
        setLoading(false);
    }

    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

  return (
    <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"HEAD BANNER"} />
        <Menu
            parentmenu={"infoBanner"}
            activemenu={"infoHeadBanner"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-banner.png" className="ic-user01 me-2" alt="" />
                                BANNER<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" />  HEAD BANNER
                            </font>
                        </Col>
                    </Row>
                    <Row>
                        <TableData
                            dataHeader={dataHeader}
                            editUrl={"/eInfoHeadBanner?id="}
                            dataTable={dataTable}
                            idName={"user_id"}
                            removeData=""
                            tableParam={tableParam}
                            sortTable={sortTable}
                            changePage={changePage}
                            changeDataPerPage={changeDataPerPage}
                            totalNumber={totalNumber}
                            tablePermission={{
                                view: false,
                                create: false,
                                delete: false,
                                update: false,
                                edit: true,
                            }}
                        />
                    </Row>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default HeadBanner;